import i18n from 'i18next'

export const getLang = (): string => i18n.language.split('-')[0]

export const getLocale = (): string => i18n.language.replace('-', '_')
